export const ATTENDANCE_META = {
  present: { label: "Présent", color: "var(--ok)" },
  late: { label: "Retard", color: "var(--just)" },
  absent: { label: "Absent", color: "var(--late)" },
};
